export var FeatureNames;
(function (FeatureNames) {
    FeatureNames["Maps"] = "Questionnaire.Maps";
    FeatureNames["LuckyOrange"] = "Questionnaire.LuckyOrange";
    FeatureNames["Preview"] = "Questionnaire.Preview";
    FeatureNames["Embed"] = "Questionnaire.Embed";
    FeatureNames["Quote"] = "Quote";
    FeatureNames["Contact"] = "Contact";
    FeatureNames["Payment"] = "Payment";
    FeatureNames["Scheduling"] = "Scheduling";
    FeatureNames["Analytics"] = "Analytics";
})(FeatureNames || (FeatureNames = {}));
